import styled from 'styled-components';

export const McDropdownWrapper = styled.div`
  .mc-options {
    top: 45px;
    width: 100%;
    overflow-y: scroll;
    max-height: 200px;
    transition: height 200ms linear 0s;
    border-radius: 12px;
    z-index: 5;
    box-sizing: border-box;

    .mc-option-item:hover {
      background: ${({ theme }) => theme.colors.backgroundColor};
      border-radius: 8px;

      label {
        color: ${({ theme }) => theme.colors.zervioBlue};
      }
    }

    .mc-option-item {
      height: 40px;
      min-height: 40px;
      overflow-x: hidden;

      label {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }

  .organisations-border {
    height: 40px;
    padding: 8px 16px;
    border: 1px solid ${({ theme }) => theme.colors.ZenGray2};
    border-radius: 16px;
  }

  .selected-name {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .dropdown-open {
    border-color: ${({ theme }) => theme.colors.zervioBlue};
  }
`;
